/* eslint-disable no-plusplus */
import map from 'lodash/map';
import _keyBy from 'lodash/keyBy';
import sortBy from 'lodash/sortBy';
import isEmpty from 'lodash/isEmpty';
import { takeLatest, call, putResolve, select } from 'redux-saga/effects';
import { getPricingFromThd } from '../api/pricingApi';
import {
  GET_PRICING,
  savePricing,
  saveUpdatedChoices,
  savePricingDetailsFromThd,
} from '../actions';
import { preloadCarpetSwatch } from '../actions/pathActions';
import { pricingNodeSelector } from '../selectors/pricing';
import { skuDataSelector } from '../selectors/skuDataSelectors';
import safeSaga from './safeSaga';
import { getHdmsStoreIdSelector } from '../selectors/thdStoreInfo';

export function* getPriceFromThd(action) {
  // configuratorChoices is all choices for supersku and filtered choices for fallback flooring
  const { choicesWithSku, carpetChoicesByIdAndSku } = action.payload;
  const storeId = yield select(getHdmsStoreIdSelector);
  const data = { storeId, skus: map(carpetChoicesByIdAndSku, 'sku') };
  const { pricingDetailsFromThd } = yield select(pricingNodeSelector);
  const hasCachedPricing = !isEmpty(pricingDetailsFromThd);
  let pricingDetailsFromThdApi = pricingDetailsFromThd;

  if (!hasCachedPricing) {
    try {
      pricingDetailsFromThdApi = yield call(getPricingFromThd, data);
      // there is still situations where an item in not available and has 0 price
      yield putResolve(savePricingDetailsFromThd(pricingDetailsFromThd));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }

  const mappedSkuPricingToChoices =
    map(
      carpetChoicesByIdAndSku,
      (choice) => ({ ...choice, ...pricingDetailsFromThdApi.skuResults[choice.sku] })
    );

  let updatedChoicesWithPrices = [];
  // SUPER SKU: there could be multiple skus for a single choiceId, so map the choices to sku
  const hasSuperSkuData = !isEmpty(yield select(skuDataSelector));
  if (hasSuperSkuData) {
    updatedChoicesWithPrices =
      map(
        mappedSkuPricingToChoices,
        (sku) => ({ ...sku, ...choicesWithSku[sku.choiceId] }));
  } else {
    // NON SUPER SKU: there is one sku for a single choiceId, so map the sku by choiceId
    const mappedSkuPricesByChoiceId = _keyBy(mappedSkuPricingToChoices, 'choiceId');
    updatedChoicesWithPrices =
      map(
        Object.values(choicesWithSku),
        (choice) => ({ ...mappedSkuPricesByChoiceId[choice.id], ...choice }));
  }
  // these sortBy functions are just for readability in redux dev tools
  yield putResolve(saveUpdatedChoices(sortBy(updatedChoicesWithPrices, 'choiceId')));
  yield putResolve(savePricing(sortBy(mappedSkuPricingToChoices), 'choiceId'));
  yield putResolve(preloadCarpetSwatch());
}

export function* getPriceFromThdSaga() {
  yield takeLatest(GET_PRICING, safeSaga(getPriceFromThd));
}
